// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202605131540/js/" + chunkId + "." + {"44":"4267a625","225":"345a7bc6","481":"7af9bc26","486":"5ab6a7bd","770":"8a9c0df6"}[chunkId] + ".0.004289836953224935.chunk.js";
};